'use strict';

+function ($) {

  $.siteSearch = function (option) {
    var $search = $('.site-search');
    switch (option) {
    case 'show':
      // initialize just in time so as not to clutter the DOM
      if ($search.is(':empty')) {
        $search.html('<div class="search-bar"><input class="search-input" type="search"><button class="close" data-dismiss="site-search" aria-label="Close" aria-hidden="true">×</button></div><div class="search-dropdown"><ul class="search-results"></ul></div></div>');
        $search.find('.search-bar')[0].offsetWidth; // forces reflow before animating in
      }
      $('html').addClass('site-search-open');
      $search.find('.search-input').focus();
      $search.trigger('shown.bc.siteSearch');
      break;
    case 'hide':
      $('html').removeClass('site-search-open');
      window.setTimeout(function () {
        $search.find('.search-input').val('');
        $search.find('.search-results').empty();
      }, 10); // a tiny delay just allows IE 11 to register that a link was clicked before that link gets removed from the DOM
      break;
    case 'toggle':
      if ($('html').hasClass('site-search-open')) {
        $.siteSearch('hide');
      } else {
        $.siteSearch('show');
      }
      break;
    }
  };

  basecoat.init.siteSearch = function () {
    // show/hide functions
    $('.site-search')
    .off('.bc.siteSearch')
    .on('show.bc.siteSearch', function () { $.siteSearch('show'); })
    .on('hide.bc.siteSearch', function () { $.siteSearch('hide'); })
    // hide search on click of 'x', or any link
    .on('click.bc.siteSearch', '[data-dismiss="site-search"], a', function () { $.siteSearch('hide'); })
    // hide search on click of backdrop
    .on('click.bc.siteSearch', function (e) {
      if (e.target !== this) return;
      $.siteSearch('hide');
    })
    // hide search on press of `esc` key
    .on('keydown.bc.siteSearch', '.search-input', function (e) {
      if (e.which === 27) { // esc
        $.siteSearch('hide');
      }
    });

    // show search on click of search button
    $('[data-toggle="site-search"]').on('click.bc.siteSearch', function () {
      $.siteSearch('show');
    });
  };

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/site-search.js
// module id = 18
// module chunks = 0